export const dropdownPrefixSelector = 'pm-dropdown';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const DropdownMenuSharedCssClassName = {
	SUBMENU: `${dropdownPrefixSelector}-submenu`,
};
